<div class="flex flex-column">

  <h2>{{'model.synoptic' | transloco}} {{synopticInfoForm.get('name').value}}</h2>

  <h4 class="mt-4 bold">{{'common.information' | transloco}}</h4>
  <div class="grid my-2">
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'attribute.description' | transloco}}</p>
      <p [class.font-italic]="!synopticInfoForm.get('description').value">
        {{synopticInfoForm.get('description').value ? synopticInfoForm.get('description').value : ("empty.description" | transloco)}}
      </p>
    </div>
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'model.tenant' | transloco}}</p>
      <p>{{synopticInfoForm.get('tenant').value.name}}</p>
    </div>
    <div class="col-12 lg:col-6 xl:col-4">
      <p class="bold p-0 m-0">{{'model.organization' | transloco}}</p>
      <p [class.font-italic]="!synopticInfoForm.get('organization').value">
        {{synopticInfoForm.get('organization').value ? synopticInfoForm.get('organization').value.name : ('empty.organization' | transloco)}}
      </p>
    </div>
  </div>

  <div class="flex flex-column gap-1 my-2">
    <p class="bold p-0 m-0">{{'forms.files' | transloco}}</p>
    <p-table [value]="synopticFiles" [paginator]="true" [rows]="5">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="name">
            {{'attribute.name' | transloco}}
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th scope="col">
            {{'common.image' | transloco}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file let-i="rowIndex">
        <tr>
          <td>
            <span class="p-column-title bold">{{ 'attribute.name'| transloco}}</span>
            {{file.name}}
          </td>
          <td>
            <span class="p-column-title bold">{{ 'common.image'| transloco}}</span>
            <app-synoptic-thumbnail [file]="file"></app-synoptic-thumbnail>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>
